// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation_Confirmation__15p9I","title":"Confirmation_title__1gN2G","content":"Confirmation_content__dM8cm","toHome":"Confirmation_toHome__1v6I3"};